import { ReservationStatus, StopType } from '@enums/trips.enum';
import type { TripStop } from '@store/trips/tripsSlice';

const PICKED_UP_STATUSES = [ReservationStatus.Picked, ReservationStatus.Dropped];

export const isPickedUp = (stops: TripStop[] | undefined): boolean => {
	return Boolean(
		stops?.some((stop) =>
			stop.passengers.some(
				(passenger) => passenger.stopType === StopType.Pick && PICKED_UP_STATUSES.includes(passenger.reservation.status),
			),
		),
	);
};
